import React from "react";
import { Clock, Users, Leaf } from "lucide-react";

export default function RecipeHistory({ history, onSelect }) {
  if (!history || history.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-4">
        <div className="rounded-2xl p-6 text-center" style={{ backgroundColor: "#F4F1EA", border: "1px solid #E5E0D8" }}>
          <Leaf size={24} className="mx-auto mb-2" style={{ color: "#9AA5B1" }} strokeWidth={1.5} />
          <p className="text-sm" style={{ color: "#9AA5B1", fontFamily: "Manrope, sans-serif" }}>
            No past recipes yet. Generate your first one above!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-4" data-testid="recipe-history">
      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: "#FFFFFF", border: "1px solid #E5E0D8" }}>
        <div className="px-6 py-4" style={{ borderBottom: "1px solid #E5E0D8" }}>
          <h3 className="font-serif font-semibold text-base" style={{ color: "#2D3436" }}>Recent Recipes</h3>
        </div>
        <div className="divide-y" style={{ borderColor: "#F4F1EA" }}>
          {history.map((recipe, i) => (
            <button
              key={recipe.id}
              data-testid={`history-item-${i}`}
              onClick={() => onSelect(recipe)}
              className="w-full text-left px-6 py-4 hover:bg-muted transition-colors flex items-start justify-between gap-4"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm truncate" style={{ color: "#2D3436" }}>
                  {recipe.recipe_name}
                </p>
                <p className="text-xs mt-0.5 truncate" style={{ color: "#9AA5B1" }}>
                  {recipe.input_ingredients.join(", ")}
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                {(recipe.input_dish_type) && (
                  <span className="text-xs px-2 py-0.5 rounded-full"
                    style={{ backgroundColor: "#F4F1EA", color: "#5D6D7E" }}>
                    {recipe.input_dish_type}
                  </span>
                )}
                <div className="flex items-center gap-1 text-xs" style={{ color: "#9AA5B1" }}>
                  <Users size={11} />
                  <span>{recipe.servings}</span>
                </div>
                <div className="flex items-center gap-1 text-xs" style={{ color: "#9AA5B1" }}>
                  <Clock size={11} />
                  <span>{recipe.cook_time}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
